// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import axios from 'axios';
// import { Container, Card } from 'react-bootstrap';
// // import './BlogDetailsPage.css'; // Updated class names
// import './../../assets/css/BlogDetailsPage.css';
// import BASE_URL from '../../component/commanfile';
// const BlogDetailsPage = () => {
//   const { id } = useParams();
//   const [blogDetails, setBlogDetails] = useState(null);

//   useEffect(() => {
//     const fetchBlogData = async () => {
//       try {
//         const response = await axios.get(
//           `${BASE_URL}api/blogs/${id}`
//         );
//         setBlogDetails(response?.data);
//       } catch (error) {
//         console.error('Error fetching blog details:', error);
//       }
//     };

//     fetchBlogData();
//   }, [id]);

//   if (!blogDetails) return <p className="blog_details-loading text-center my-5">Loading...</p>;

//   const { title, thumbnail, shortDescription, blog_type, blog_details ,type, fileBase64, details} = blogDetails;

//   return (
//     <div className="blog_details-page">
//       {/* Hero Section */}
//       <div className="blog_details-hero-image" style={{ backgroundImage: `url(${BASE_URL}/api/image?file=${encodeURIComponent(thumbnail)})` }}>
//         <div className="blog_details-hero-text">
//           <h1>{title}</h1>
//         </div>
//       </div>

//       <Container className="my-5">
//         <h2 className="blog_details-title">{title}</h2>
//         <p className="blog_details-type text-uppercase text-muted">{type}</p>
//         <p className="blog_details-short-description">{shortDescription}</p>

//         {details?.map((detail) => (
//           <Card className="blog_details-card my-4 shadow" key={detail.id}>
//             {detail.type === 'image' && (
//               <img
//                 variant="top"
//                 // src={detail.fileBase64}
//                 src={`${BASE_URL}/api/image?file=${encodeURIComponent(detail?.file_path)}`}
//                 alt="Blog Detail"
//                 className="blog_details-image"
//               />
//             )}
// {detail.type === 'video' && (
//   <div className="blog_details-video-wrapper">
//     <video autoPlay width="100%" className="blog_details-video">
//       <source src={`${BASE_URL}/api/image?file=${encodeURIComponent(detail?.file_path)}`} type="video/mp4" />
//       Your browser does not support the video tag.
//     </video>
//   </div>
// )}
//             <Card.Body className="blog_details-body">
//               <div
//                 className="blog_details-description"
//                 dangerouslySetInnerHTML={{ __html: detail.description }}
//               />
//             </Card.Body>
//           </Card>
//         ))}
//       </Container> 
//     </div>
//   );
// };

// export default BlogDetailsPage;


import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Container, Badge, Spinner } from 'react-bootstrap';
import { FaClock, FaUserEdit, FaShareAlt } from 'react-icons/fa';
import './../../assets/css/BlogDetailsPage.css';
import BASE_URL from '../../component/commanfile';

const BlogDetailsPage = () => {
  const { id } = useParams();
  const [blogDetails, setBlogDetails] = useState(null);

  useEffect(() => {
    const fetchBlogData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}api/blogs/${id}`);
        setBlogDetails(response?.data);
      } catch (error) {
        console.error('Error fetching blog details:', error);
      }
    };
    fetchBlogData();
  }, [id]);

  if (!blogDetails) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '80vh' }}>
        <Spinner animation="border" variant="danger" />
      </div>
    );
  }

  const { title, thumbnail, shortDescription, type, details } = blogDetails;

  const styles = {
    heroSection: {
      position: 'relative',
      height: '70vh',
      minHeight: '500px',
      backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.6)), url(${BASE_URL}/api/image?file=${encodeURIComponent(thumbnail)})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed', // Parallax effect
      display: 'flex',
      alignItems: 'flex-end',
      color: 'white',
      paddingBottom: '60px'
    },
    metaBadge: {
      backgroundColor: '#8f0909',
      padding: '8px 16px',
      borderRadius: '50px',
      fontSize: '0.85rem',
      fontWeight: '600'
    },
    contentArea: {
      maxWidth: '850px',
      margin: '0 auto',
      lineHeight: '1.8',
      fontSize: '1.15rem',
      color: '#333'
    },
    mediaWrapper: {
      borderRadius: '24px',
      overflow: 'hidden',
      boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
      margin: '40px 0'
    }
  };

  return (
    <div style={{ backgroundColor: '#fff', fontFamily: "'Inter', sans-serif" }}>
      
      {/* 1. IMMERSIVE HERO */}
      <div style={styles.heroSection}>
        <Container>
          <div style={{ maxWidth: '800px' }}>
            <Badge style={styles.metaBadge} className="mb-3 text-uppercase">
              {type || 'Travel'}
            </Badge>
            <h1 style={{ fontSize: 'calc(2rem + 2vw)', fontWeight: '800', textShadow: '2px 2px 10px rgba(0,0,0,0.3)' }}>
              {title}
            </h1>
            <div className="d-flex align-items-center mt-4 opacity-75">
              <FaUserEdit className="me-2" /> <span className="me-4">Radheshyam Editor</span>
              <FaClock className="me-2" /> <span>6 Min Read</span>
            </div>
          </div>
        </Container>
      </div>

      <Container className="py-5">
        <div style={styles.contentArea}>
          
          {/* 2. INTRODUCTION */}
          <p style={{ fontSize: '1.4rem', color: '#666', fontWeight: '300', fontStyle: 'italic', borderLeft: '4px solid #8f0909', paddingLeft: '20px' }} className="mb-5">
            {shortDescription}
          </p>

          {/* 3. DYNAMIC CONTENT SECTION */}
          {details?.map((detail, index) => (
            <div key={detail.id || index} className="mb-5">
              
              {/* Image Rendering */}
              {detail.type === 'image' && (
                <div style={styles.mediaWrapper}>
                  <img
                    src={`${BASE_URL}/api/image?file=${encodeURIComponent(detail?.file_path)}`}
                    alt="Radheshyam Travels blog content"
                    style={{ width: '100%', height: 'auto', display: 'block' }}
                  />
                </div>
              )}

              {/* Video Rendering */}
              {detail.type === 'video' && (
                <div style={styles.mediaWrapper}>
                  <video 
                    controls 
                    width="100%" 
                    style={{ backgroundColor: '#000' }}
                  >
                    <source src={`${BASE_URL}/api/image?file=${encodeURIComponent(detail?.file_path)}`} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              )}

              {/* Description Rendering */}
              <div
                className="blog-rich-text"
                style={{ textAlign: 'justify' }}
                dangerouslySetInnerHTML={{ __html: detail.description }}
              />
            </div>
          ))}

          {/* 4. SHARE SECTION */}
          <div className="mt-5 pt-5 border-top d-flex justify-content-between align-items-center">
            <h5 className="fw-bold">Enjoyed this post?</h5>
            <button className="btn btn-outline-dark rounded-pill px-4">
              <FaShareAlt className="me-2" /> Share Journey
            </button>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default BlogDetailsPage;